module.exports = __webpack_public_path__ + "static/media/kredyt_20.9a3edd93.png";